import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { EmptyState } from 'components';
import GenderIcon from 'components/GenderIcon';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from "react-router-dom";
import { StudentAdd } from './components';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));
let mounted = false;

const AccountStudents = props => {
  const { className, reload, ...rest } = props;
  const model = useSelector(state => state.models.account);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    if (mounted) setOpenEdit(true);
  };

  const handleEditClose = () => {
    if (mounted) setOpenEdit(false);
  };

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, [])

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Account Students" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            {model.students.map((student, index) => (
              <TableRow key={index}>
                <TableCell className={classes.header}>
                  {student.name_en}{student.name_zh ? " " + student.name_zh : ""}<GenderIcon gender={student.gender} />
                  <div><Typography variant="caption">Student</Typography></div>
                </TableCell>
                <TableCell>
                  {moment(student.birthdate).format("DD/MM/YYYY")}
                  <div><Typography variant="caption">Date of Birth</Typography></div>
                </TableCell>
                <TableCell>
                  {student.xp_total || "0"}
                  <div><Typography variant="caption">Total XP</Typography></div>
                </TableCell>
                <TableCell align="right">
                  <Button color="primary" component={RouterLink} size="small" to={`/students/${student.id}/summary`} variant="outlined">
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <EmptyState active={!model.students.length} />
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <AddIcon className={classes.buttonIcon} />
          Add
        </Button>
      </CardActions>
      <StudentAdd onClose={handleEditClose} reload={reload} open={openEdit} model={model} />
    </Card>
  );
};

AccountStudents.propTypes = {
  className: PropTypes.string,
};

export default AccountStudents;
